import React, { useEffect, useState } from 'react';
import axios from 'axios';

const columns = [['first_name', 'First Name'], ['last_name', 'Last Name'], ['empresa', 'Empresa'], ['email', 'Email'],
  ['contacto', 'Contacto'], ['cliente_id', 'ID de cliente'], ['url_linkedin', 'LinkedIn']];
const pageSize = 25;

export function ListContents({ list, onBack }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(0);

  useEffect(() => {
    let active = true;
    axios.get(`/api/user/list-leads/${encodeURIComponent(list.id)}`)
      .then(response => { if (active) setRecords(response.data.data); })
      .catch(() => { if (active) setError('No se pudo cargar el contenido de la lista. Vuelve a Listas e inténtalo de nuevo.'); })
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, [list.id]);

  const filtered = records.filter(row => columns.some(([key]) =>
    String(row[key] || '').toLocaleLowerCase().includes(search.trim().toLocaleLowerCase())));
  const visible = filtered.slice(page * pageSize, (page + 1) * pageSize);

  return <section style={{ marginTop: '2em' }}>
    <button type="button" onClick={onBack}>Volver a Listas</button>
    <h2>{list.name}</h2>
    {loading ? <p role="status">Cargando leads…</p> : error ? <p role="alert">{error}</p> : <>
      <p>{records.length} leads</p>
      <label>Buscar en la lista
        <input type="search" value={search} onChange={event => { setSearch(event.target.value); setPage(0); }} />
      </label>
      <div style={{ overflowX: 'auto', marginTop: '1em' }}>
        <table style={{ width: '100%', background: 'var(--df-surface)' }}>
          <thead><tr>{columns.map(([key, title]) => <th key={key} scope="col" style={{ padding: 12, textAlign: 'left' }}>{title}</th>)}</tr></thead>
          <tbody>{visible.map(row => <tr key={row.id}>{columns.map(([key]) =>
            <td key={key} style={{ padding: 12, borderBottom: '1px solid var(--df-border)', overflowWrap: 'anywhere' }}>{row[key] || '—'}</td>
          )}</tr>)}{!visible.length && <tr><td colSpan={columns.length}>{records.length ? 'No hay resultados para esta búsqueda.' : 'Esta lista no contiene leads disponibles.'}</td></tr>}</tbody>
        </table>
      </div>
      {!!filtered.length && <nav aria-label="Páginas de leads" style={{ display: 'flex', gap: '1em', alignItems: 'center', marginTop: '1em' }}>
        <button type="button" disabled={page === 0} onClick={() => setPage(value => value - 1)}>Anterior</button>
        <span>Página {page + 1} de {Math.ceil(filtered.length / pageSize)} · {filtered.length} resultados</span>
        <button type="button" disabled={(page + 1) * pageSize >= filtered.length} onClick={() => setPage(value => value + 1)}>Siguiente</button>
      </nav>}
    </>}
  </section>;
}
